module.exports = __webpack_public_path__ + "img/user3.99b659b8.png";